import { render, staticRenderFns } from "./SidebarNavIS.vue?vue&type=template&id=7dc4441b&scoped=true"
import script from "./SidebarNavIS.vue?vue&type=script&lang=js"
export * from "./SidebarNavIS.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavIS.vue?vue&type=style&index=0&id=7dc4441b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc4441b",
  null
  
)

export default component.exports